import React from "react";
import AppRoutes from "./router";
import AuthProvider from "./contexts/AuthContext";
import AdminProvider from "./contexts/AdminContext";
import ErrorBoundary from "./components/App/ErrorBoundary";
import { ErrorDialogProvider } from "./contexts/ErrorDialogContext";
import { SuccessDialogProvider } from "./contexts/SuccessDialogContext";
import { UnsavedDataProvider } from "./contexts/UnsavedDataContext";
import { PatchingReminderProvider } from "./contexts/PatchingReminderContext";
import { SubscriptionStatusProvider } from "./contexts/SubscriptionStatusContext";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <ErrorBoundary>
      <ErrorDialogProvider>
        <SuccessDialogProvider>
          <BrowserRouter>
            <AuthProvider>
              <AdminProvider>
                <SubscriptionStatusProvider>
                  <PatchingReminderProvider>
                    <UnsavedDataProvider>
                      <AppRoutes />
                    </UnsavedDataProvider>
                  </PatchingReminderProvider>
                </SubscriptionStatusProvider>
              </AdminProvider>
            </AuthProvider>
          </BrowserRouter>
        </SuccessDialogProvider>
      </ErrorDialogProvider>
    </ErrorBoundary>
  );
}

export default App;
